<template>
  <v-container fluid class="package-listing-page-settings" v-if="settings">
    <v-row class="flex-grow-1">
      <v-col>
        <v-form ref="packageListingPageForm">
          <v-row>
            <v-col>
              <v-input hide-details="auto"
                       v-model="settings.banner"
                       :rules="requiredRules">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_acc_package_page.banner') }}</legend>
                  <PhotoPreviewInput v-model="settings.banner"
                                     div-class="package-list-banner"
                                     file-name="package-list-banner"></PhotoPreviewInput>
                  <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>2545px(W) X 1081px(H)</b></small>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
          <v-row class="pt-0"
                 v-for="field in fields"
                 :key="field">
            <v-col>
              <v-input hide-details
                       v-model="settings[field]">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t(`admin_acc_package_page.${field}`) }}</legend>
                  <TinyMceEditor v-model="settings[field]"></TinyMceEditor>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <v-footer>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             depressed
             large
             @click="$refs.packageListingPageForm.validate() && save()">
        {{ $t('save') }}
        <v-icon right>fas fa-check</v-icon>
      </v-btn>
    </v-footer>
  </v-container>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import TinyMceEditor from "@/components/TinyMceEditor";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";

export default {
  name: 'PackageListingPageSettings',
  components: {PhotoPreviewInput, TinyMceEditor},
  setup(props, {root}) {
    onMounted(()=> {
      getSettings();
    })

    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const settings = ref(null);
    const getSettings = function () {
      root.$callAPI('aafb/admin/package/settings/', {}, (response) => {
        settings.value = {
          banner: null,
          header_en: '',
          header_zh: '',
          subheader_en: '',
          subheader_zh: '',
          content_en: '',
          content_zh: '',
          footer_en: '',
          footer_zh: '',
          ...response.body.settings,
        }
      })
    };
    const fields = ref([
      'header_en',
      'header_zh',
      'subheader_en',
      'subheader_zh',
      'content_en',
      'content_zh',
      'footer_en',
      'footer_zh',
    ])

    const save = async function () {
      root.$callAPI('aafb/admin/package/settings/set/', {
        ...settings.value,
        banner: settings.value.banner instanceof File ? await root.$convertFileToBase64(settings.value.banner) : settings.value.banner,
      }, () => {
        getSettings();
      })
    };

    return {
      requiredRules,

      settings,
      fields,

      save,
    }
  },
}
</script>

<style lang="less">
.package-listing-page-settings {
  height: 100% !important;
  display: flex;
  flex-direction: column;

  .footer-row {
    background-color: #ebecee;
    flex-grow: 0;
  }
}
</style>
